<template>
    <div>
        <el-card shadow="hover">
            <el-form inline :model="query" size="small">
                <div @keydown.enter="doLoad()">
                    <div style="float: left;">
                        <el-form-item>
                            <el-select v-model="query.pid" placeholder="请选择招聘计划" style="width:250px;" @change="doLoad">
                                <el-option v-for="plan in plans" :key="plan.id" :label="plan.name" :value="plan.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
            </el-form>
        </el-card>
        <template v-if="data.all">
            <el-alert type="success" style="margin-top: 5px;" :closable="false">
                <p solt="title">
                    总计信息：共支付{{ data.all.count }}笔， 合计{{ data.all.total }}元，手续费{{ data.all.fee }}元，退款{{ data.all.refund }}笔，退款金额{{ data.all.ramt }}元，到账金额{{ data.all.amt }}元
                </p>
            </el-alert>
            <el-alert type="warning" style="margin-top: 5px;" :closable="false">
                <p solt="title">微信支付：支付{{ data.wxpay.count }}笔， 合计{{ data.wxpay.total }}元，手续费{{ data.wxpay.fee }}元，退款{{ data.wxpay.refund }}笔，退款金额{{ data.wxpay.ramt }}元</p>
            </el-alert>
            <el-alert type="error" style="margin-top: 5px;" :closable="false">
                <p solt="title">支付宝：支付{{ data.alipay.count }}笔， 合计{{ data.alipay.total }}元，手续费{{ data.alipay.fee }}元，退款{{ data.alipay.refund }}笔，退款金额{{ data.alipay.ramt }}元</p>
            </el-alert>
        </template>
        <!--Table-->
        <el-card shadow="hover" style="margin-top: 10px;">
            <el-table ref="table" v-loading="tableLoading" :data="datas" highlight-current-row :border="true" stripe tooltip-effect="dark" style="width: 100%">
                <el-table-column show-overflow-tooltip label="岗位信息" width="250">
                    <template slot-scope="scope">
                        <p>
                            <span>[{{ scope.row.post.code }}] {{ scope.row.post.name }}</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="招聘单位">
                    <template slot-scope="scope">
                        <p>
                            {{ scope.row.post.unit }}
                            <span v-if="scope.row.post.dept">[{{ scope.row.post.dept }}]</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="报名人数" width="150">
                    <template slot-scope="scope">
                        <p>
                            <span>{{ scope.row.regs }}人</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="通过人数" width="150">
                    <template slot-scope="scope">
                        <p>
                            <span>{{ scope.row.pass }}人</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="缴费人数" width="150">
                    <template slot-scope="scope">
                        <p>
                            <span>{{ scope.row.paid }}人</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="报名费" width="150">
                    <template slot-scope="scope">
                        <p>
                            <span>￥{{ scope.row.rfee }}</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="小计金额" width="150">
                    <template slot-scope="scope">
                        <p>
                            <span>￥{{ scope.row.amt }}</span>
                        </p>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
    </div>
</template>

<script>
const defaultQuery = {
    pid: ''
}

export default {
    name: 'RecSettle',
    data() {
        return {
            query: {
                ...defaultQuery
            },
            data: {
                count: 0,
                regs: 0,
                pass: 0,
                paid: 0
            },
            tableLoading: false,
            datas: [],
            plans: []
        }
    },
    mounted() {
        this.$store.commit('setBreadcrumb', ['招聘管理', '核算信息'])
        this.init()
    },

    methods: {
        init() {
            this.doLoadPlan()
        },
        doLoadPlan() {
            this.$http
                .get('/comm/data/plan/query', {
                    params: {
                        _: new Date().getTime()
                    }
                })
                .then(result => {
                    this.plans = result.datas
                })
        },
        doLoad() {
            if (!this.query.pid) {
                this.$message.warning('请选择招聘计划')
                return
            }
            this.tableLoading = true
            this.$http
                .get('/ops/finance/settle/list', {
                    params: this.query
                })
                .then(result => {
                    this.tableLoading = false
                    if (result.data.page === 1) {
                        this.query.time = result.data.time
                    }
                    this.data = result.data
                    this.datas = result.datas
                })
        }
    }
}
</script>
